import script from "./ToolsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsLayout.vue?vue&type=script&setup=true&lang=js"

import "@/styles/console.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__